import React, { useEffect, useRef } from 'react';

import { AchadoDoAssistente } from '../../api/radarApi';
import { formatarCelula } from './formatarCelula';
import './radar.css'; // `.do-modal-largo` e o visual da tabela do modal
import '../../shared/ui/modal-close-button.css'; // X padrão do sistema

interface Props {
  achado: AchadoDoAssistente;
  onClose: () => void;
}

/**
 * As linhas da consulta que ancora um achado do assistente (contac/at-12, generalizado na at-82).
 *
 * Diferente dos modais de detalhe, este **não consulta nada**: as linhas vieram na própria
 * resposta dos achados — são exatamente o resultado de que o servidor leu o número do cartão, e
 * buscá-las de novo poderia divergir do número exibido.
 */
const LinhasDoAchadoModal: React.FC<Props> = ({ achado, onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cliqueFora = (evento: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(evento.target as Node)) onClose();
    };
    const escape = (evento: KeyboardEvent) => {
      if (evento.key === 'Escape') onClose();
    };

    document.addEventListener('mousedown', cliqueFora);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('mousedown', cliqueFora);
      document.removeEventListener('keydown', escape);
    };
  }, [onClose]);

  return (
    <div className="modal-overlay">
      <div className="do-modal do-modal-largo" ref={modalRef}>
        <div className="do-modal-header">
          <span className="do-modal-titulo">{achado.titulo}</span>
          <button type="button" className="close-button" onClick={onClose} aria-label="Fechar">
            &times;
          </button>
        </div>

        <div className="do-modal-corpo">
          <p className="do-modal-apoio">
            As linhas da consulta que sustenta este achado — o número do cartão foi lido daqui.{' '}
            {achado.linhas.length} {achado.linhas.length === 1 ? 'linha' : 'linhas'} (lista
            limitada; o corte, quando houver, está declarado no botão ? do cartão).
          </p>

          {achado.linhas.length === 0 ? (
            <p className="do-modal-apoio">A consulta não devolveu linhas.</p>
          ) : (
            <div className="do-tabela-wrapper">
              <table className="do-tabela">
                <thead>
                  <tr>
                    {achado.colunas.map((coluna) => (
                      <th key={coluna.chave}>{coluna.rotulo}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {achado.linhas.map((linha, indice) => (
                    <tr key={indice}>
                      {achado.colunas.map((coluna) => {
                        const valor = formatarCelula(linha[coluna.chave], coluna);
                        return (
                          // Uma linha por célula, com reticências e o valor inteiro no title.
                          <td key={coluna.chave} title={valor}>
                            {valor}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LinhasDoAchadoModal;
